import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../static/img/logo.png";
import "../static/css/Nav.css";

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="Nav-bar">
        <div className="nav-content">
          <img src={logo} alt="Logo" />
          <span className="menu-icon" onClick={toggleSidebar}>
            &#9776;
          </span>
          <ul>
            <Link to="/">
              <li>Home</li>
            </Link>
            <Link to="/team">
              <li>Our Team</li>
            </Link>
            <Link to="/services">
              <li>Services</li>
            </Link>
            <Link to="/publications">
              <li>Publications</li>
            </Link>
            <Link to="/events">
              <li>Events & Calendar</li>
            </Link>
            <Link to="/gallery">
              <li>Gallery</li>
            </Link>
            <Link to="/career">
              <li>Career</li>
            </Link>
            <Link to="/contact">
              <li>Contact Us</li>
            </Link>
            <div className="Log-In">
              <Link to="/login">
                <button>Login</button>
              </Link>
            </div>
          </ul>
        </div>
      </div>
      <div className="sidebar" style={{ width: isOpen ? "250px" : "0" }}>
        <span className="closebtn" onClick={toggleSidebar}>
          &times;
        </span>
        <Link to="/login">
          <li className="Log-In">Log In</li>
        </Link>
        <ul>
          <Link to="/">
            <li>Home</li>
          </Link>
          <Link to="/team">
            <li>Our Team</li>
          </Link>
          <Link to="/services">
            <li>Services</li>
          </Link>
          <Link to="/publications">
            <li>Publications</li>
          </Link>
          <Link to="/events">
            <li>Events & Calendar</li>
          </Link>
          <Link to="/gallery">
            <li>Gallery</li>
          </Link>
          <Link to="/career">
            <li>Career</li>
          </Link>
          <Link to="/contact">
            <li>Contact Us</li>
          </Link>
        </ul>
      </div>
    </>
  );
}

export default Nav;
